import {v4 as uuidv4} from "uuid";
import fileSize from "filesize";

/**
 * FileHelper::getIconClass()
 *
 * @param extension
 * @returns {string}
 */
export const getIconClass = (extension) => {
    switch (extension) {
        case 'doc':
        case 'docm':
        case 'docx':
        case 'dot':
        case 'dotm':
        case 'dotx':
            return 'fas fa-file-word';
        case 'odt':
        case 'txt':
        case 'rtf':
            return 'fas fa-file-alt';
        case 'pptx':
        case 'pptm':
        case 'ppt':
        case 'potx':
        case 'potm':
        case 'pot':
        case 'ppsx':
        case 'pps':
            return 'fas fa-file-powerpoint';
        case 'pdf':
            return 'fas fa-file-pdf';
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'tiff':
            return 'fas fa-file-image';
        case 'mp3':
        case 'aac':
        case 'aax':
        case 'aiff':
        case 'alac':
        case 'flac':
        case 'm4a':
        case 'm4b':
        case 'm4p':
        case 'ogg':
        case 'oga':
        case 'mogg':
        case 'tta':
        case 'wav':
            return 'fas fa-file-music';
        case 'webm':
        case 'mkv':
        case 'flv':
        case 'f4v':
        case 'f4p':
        case 'f4a':
        case 'f4b':
        case 'vob':
        case 'ogv':
        case 'avi':
        case 'mov':
        case 'wmv':
        case 'rm':
        case 'mp4':
        case 'm4v':
        case 'mpg':
        case 'mpeg':
        case 'mp2':
            return 'fas fa-file-video';
        case 'xlsx':
        case 'xlsm':
        case 'xlsb':
        case 'xltx':
        case 'xls':
        case 'xlt':
        case 'xla':
        case 'xlw':
        case 'xlr':
            return 'fas fa-file-excel';
        case 'zip':
        case 'rar':
        case '7z':
        case 'tar':
            return 'fas fa-file-archive';
        case 'csv':
            return 'fas fa-file-csv';
        default:
            return 'fas fa-file';
    }
}

/**
 * FileHelper::getFileExtension()
 *
 * @param file
 * @returns {*}
 */
export const getFileExtension = (file) => {
    return file.path.split('.').pop();
}

/**
 * FileHelper::clientSideUpload()
 *
 * @param file
 * @returns {{path, extension: *, file, size, display_size: string, icon: string, id: (*|string)}}
 */
export const clientSideUpload = async (file) => {
    let fileExtension = getFileExtension(file)

    const base64 = await fileToBase64(file).catch((e) => Error(e));
    if (base64 instanceof Error) {
        console.log('Error: ', base64.message);
        return;
    }

    return {
        id:             uuidv4(),
        name:           file.name,
        file:           file,
        path:           file.path,
        url:            null,
        size:           file.size,
        display_size:   fileSize(file.size),
        extension:      fileExtension,
        icon:           getIconClass(fileExtension),
        base64:         base64,
        created_at:     null,
        new_upload:     1,
        deleted:        0
    }
}

/**
 * FileHelper::uploadToServer()
 *
 * @param file
 * @returns {{path, extension: ((function(): *)|*|((mime: string) => (string | undefined))), deleted: (number|*), size, name, display_size: *, icon, base64: (*), id, url}}
 */
export const uploadToServer = (file) => {
    return {
        id:             file.id,
        name:           file.name,
        path:           file.path,
        url:            file.url,
        size:           file.size,
        display_size:   file.display_size,
        extension:      file.extension,
        icon:           file.icon,
        base64:         file.base64,
        created_at:     file.created_at,
        new_upload:     file.new_upload,
        deleted:        file.deleted
    }
}

/**
 * FileHelper::fileToBase64()
 *
 * @param file
 * @returns {Promise<unknown>}
 */
const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});
